// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"74a043f9","563":"a2c5e279","977":"a9c27935"}[chunkId] + ".chunk.js";
};